"use strict";
exports.__esModule = true;
exports.useCache = void 0;
var React = require("react");
exports.useCache = function (cacheConfig) {
    var _a = React.useState(), map = _a[0], setMap = _a[1];
    var _b = React.useState({}), cache = _b[0], setCache = _b[1];
    var _c = React.useState([]), pins = _c[0], setPins = _c[1];
    var _d = React.useState(), cacheData = _d[0], setCacheData = _d[1];
    var _e = React.useState(), viewport = _e[0], setViewport = _e[1];
    var _f = React.useState(false), forceUpdate = _f[0], setForceUpdate = _f[1];
    var getViewport = function () {
        var bound = map.getBounds();
        var ne = bound.getNorthEast();
        var sw = bound.getSouthWest();
        return {
            bound: {
                ne: { lat: ne.lat(), lng: ne.lng() },
                sw: { lat: sw.lat(), lng: sw.lng() }
            },
            zoom: map.getZoom()
        };
    };
    var showViewportPins = function (cache, viewport) {
        return setPins(cacheConfig.retrieveCallback(cache, viewport));
    };
    var addCacheData = function (cacheData) { return setCacheData(cacheData); };
    var onViewportChanged = function (newViewport) { return setViewport(newViewport); };
    React.useEffect(function () {
        if (!cacheData)
            return setCache({});
        if (!cacheData.viewport && cacheData.forceUpdate) {
            return setForceUpdate(true);
        }
        var newCache = cacheConfig.unionCallback(cache, cacheData.viewport, cacheData.pins);
        setCache(newCache);
        if (cacheData.forceUpdate) {
            setForceUpdate(true);
        }
    }, [cacheData]);
    React.useEffect(function () {
        if (!viewport)
            return;
        showViewportPins(cache, viewport);
    }, [viewport]);
    React.useEffect(function () {
        if (!map)
            return;
        setViewport(getViewport());
        if (forceUpdate) {
            showViewportPins(cache, viewport);
            setForceUpdate(false);
        }
    }, [cache, forceUpdate]);
    return { pins: pins, addCacheData: addCacheData, setMap: setMap, onViewportChanged: onViewportChanged };
};
